module.exports = __webpack_public_path__ + "3c8b1f3cbceaf5dc2b83122bb7749a5a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/tiers/wing-6.png
// module id = 3018
// module chunks = 0